// extracted by css-extract-rspack-plugin
export default {"socialLink":"_d495c778","socialTooltip":"_54a1934d","socialIcon":"_3fc94273","discordInput":"_20b071b1","focusVisible":"_64cdd1ec"};